import ArtistInput from './ArtistInput';

export default ArtistInput;
